<script setup lang="ts">
    const props = defineProps({
        class: {
            type: String,
            required: false
        },
        width: {
            type: Number,
            default: 1,
            required: false
        },
        type: {
            type: String as () => 'menu' | 'voucher',
            default: 'menu',
        },
    })

    const classObject = reactive({
        'w-50 max-md:w-[12rem]' : props.width == 1,
        'p-[1.6rem] text-[1.4rem] leading-[1.5] bg-[bgSecond] font-bold min-w-[27rem]' : props.type == 'menu',
        'min-w-[14.4rem] leading-[1.5] text-[1.4rem]' : props.type == 'voucher',
    })
</script>

<template>
    <dt 
        :class="[
            classObject, 
            props.class
        ]"
    >
        <slot />
    </dt>
</template>